// extracted by mini-css-extract-plugin
export default {"data":"page_data__RCMlM","body":"page_body__+d7NS","title":"page_title__ugQgb","contentWrapper":"page_contentWrapper__VOSPM"};